// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2CXN9","info":"UpdateTermsInfo_info__12pHS"};